import React, { Component, Fragment } from 'react';

import {
	Dialog, Icon, Pane, Paragraph, toaster,
} from 'evergreen-ui';
import { Link } from 'react-router-dom';
import QueryString from 'query-string';
import { StyledList } from '../../../../components/utilities/styledComponents/StyledList';
import api from '../../../../services/api';

import { ContentTitle } from '../../../../components/utilities/styledComponents/ContentTitle';
import ListTable from '../../../../components/ListTable';
import { LoaderFull, LoaderMain } from '../../../../components/Loader';
import { StyledButton } from '../../../../components/utilities/styledComponents/StyledButton';
import PaginatorLink from '../../../../components/PaginatorLink';
import adsTemplateImg from '../../../../img/ads-templates.png';

export default class List extends Component {
	constructor(props) {
		super(props);

		this.state = {
			data: false,
			templateCount: 0,
			itemsPerPage: 10,
			orderBy: '',
			showModal: false,
			itemListId: 0,
			needData: false,
			page: 1,
			nextPage: null,
			prevPage: null,
		};

		this.elementsData = {
			keys: [
				{
					col: 'title', title: 'Nome', sort: true, id: 'title',
				},
				{
					col: 'platform', title: 'Canal', sort: true, id: 'platform',
				},
				{
					col: 'objective', title: 'Objetivo', sort: true, id: 'objective',
				},
			],
			actions: [
				{ action: 'edit', name: 'Abrir', link: '/backoffice/templates' },
				{ action: 'delete', name: <i className="fa fa-trash" aria-hidden="true" /> },
			],
		};

		this.orderOptions = [
			{ value: 'created_at', label: 'Data' },
			{ value: 'title', label: 'Nome' },
			{ value: 'platform', label: 'Canal' },
		];

		this.itensPerPageOptions = [
			{ value: '10', label: '10' },
			{ value: '20', label: '20' },
			{ value: '30', label: '30' },
			{ value: '50', label: '50' },
			{ value: '100', label: '100' },
		];

		this.url = '/ads_templates';
		this.getData = this.getData.bind(this);
		this.setUrlParams = this.setUrlParams.bind(this);
		this.toPage = this.toPage.bind(this);
	}

	componentDidMount() {
		this.getData();
	}

	componentDidUpdate() {
		const { needData } = this.state;

		if (needData) {
			this.getData();
		}
	}

	getData = () => api.get(`${this.url}${this.setUrlParams()}`)
		.then(response => this.setState({
			data: this.buildObjectData(response.data.data),
			templateCount: response.data.meta.total,
			needData: false,
			page: response.data.meta.current_page,
			prevPage: this.getPageFromLink(response.data.links.prev),
			nextPage: this.getPageFromLink(response.data.links.next),
		})).catch(() => {
			this.setState({ needData: false });
			toaster.danger(
				'Ops! Ocorreu um erro, tente novamente mais tarde.',
			);
		});

	setUrlParams = () => {
		const {
			orderBy,
			itemsPerPage,
			page,
		} = this.state;

		const params = [];

		if (orderBy) {
			params.orderBy = orderBy;
		}

		if (page) {
			params.page = page;
		}

		if (itemsPerPage) {
			params.itemsPerPage = itemsPerPage;
		}

		return `?${QueryString.stringify(params)}`;
	};

	getPageFromLink = (link) => {
		if (link) {
			const parsed = QueryString.parse(QueryString.extract(link));
			return parsed.page || null;
		}
		return link;
	};

	toPage = (toPage) => {
		this.setState({
			needData: true, page: toPage,
		});
	};

	buildObjectData = values => values.map(data => ({
			id: data.id,
			title: data.attributes.title,
			platform: data.attributes.platform,
			objective: data.attributes.objective_text,
		}));

	removeTemplateList = id => this.setState({ showModal: true, itemListId: id });

	confirmRemoveTemplateList = () => {
		const { itemListId } = this.state;

		api.delete(`${this.url}/${itemListId}`)
			.then(() => {
				toaster.success(
					'Template deletado com sucesso!',
				);
				this.getData();
			})
			.catch((error) => {
				if (error.response.status === 403) {
					return toaster.danger(
						'Ação não autorizada!',
					);
				}

				if (error.response.status === 404) {
					return toaster.danger(
						'Template não encontrado!',
					);
				}

				return toaster.danger(
					'Ops! Ocorreu um erro, tente novamente mais tarde.',
				);
			})
			.finally(this.setState({
				showModal: false, needData: true, itemListId: 0,
			}));
	};

	render() {
		const {
			templateCount, data, showModal, needData, prevPage, nextPage, page,
		} = this.state;

		if (!data) {
			return (
				<LoaderFull />
			);
		}

		return (
			<Fragment>
				<ContentTitle className="d-flex justify-content-between">
					Templates de anúncios

					<StyledButton>
						<Link to="/backoffice/templates/cadastro" className="btn btn-register-user">Cadastrar um novo template</Link>
					</StyledButton>
				</ContentTitle>

				<StyledList>
					<header className="mb-5">
						<img src={adsTemplateImg} className="image mr-2" alt="" />
						<strong>Templates cadastrados</strong>
					</header>

					<form className="form-inline d-flex">
						<b className="flex-fill">{`${templateCount} Template${templateCount > 1 ? 's' : ''}`}</b>
						{templateCount ? (
							<Fragment>
								<div className="form-group m-2">
									<label className="field-label" htmlFor="orderBy">Ordenar por</label>
									<select
										id="orderBy"
										onChange={event => this.setState({
                                            orderBy: event.target.value,
                                            needData: true,
                                        })}
										className="form-control select mx-2"
									>
										<option value="">Selecionar...</option>
										{this.orderOptions.map(option => (
											<option value={option.value}>{option.label}</option>
                                        ))}
									</select>
								</div>
								<div className="form-group">
									<label htmlFor="pageItems">Itens por página:</label>
									<select
										id="pageItems"
										onChange={event => this.setState({
                                            itemsPerPage: event.target.value,
                                            needData: true,
                                        })}
										className="form-control select mx-2"
									>
										{this.itensPerPageOptions.map(option => (
											<option value={option.value}>{option.label}</option>
                                        ))}
									</select>
								</div>
							</Fragment>
                        ) : ''}
					</form>

					{needData ? (<LoaderMain />) : (
						<Fragment>
							<PaginatorLink
								page={page}
								nextPage={nextPage}
								prevPage={prevPage}
								className={templateCount === 0 ? 'd-none' : 'pull-right mt-4'}
								onclickNextPage={() => this.toPage(nextPage)}
								onclickPrevPage={() => this.toPage(prevPage)}
							/>
							<ListTable
								keys={this.elementsData.keys}
								actions={this.elementsData.actions}
								funcDelete={this.removeTemplateList}
								elements={data}
							/>
							<PaginatorLink
								page={page}
								nextPage={nextPage}
								prevPage={prevPage}
								className={templateCount === 0 ? 'd-none' : 'pull-right mb-4'}
								onclickNextPage={() => this.toPage(nextPage)}
								onclickPrevPage={() => this.toPage(prevPage)}
							/>
						</Fragment>
)}

				</StyledList>

				<Pane>
					<Dialog
						isShown={showModal}
						intent="danger"
						title="Tem certeza que deseja excluir esse template?"
						onCloseComplete={() => this.setState({ showModal: false })}
						onConfirm={() => this.confirmRemoveTemplateList(() => {})}
						confirmLabel="Excluir template"
					>
						<Pane
							display="flex"
							alignItems="center"
							justifyContent="center"
						>
							<Paragraph marginTop={15}>
								<Icon
									icon="warning-sign"
									color="danger"
									title="Aviso importante"
									marginRight={5}
								/>
								Você está prestes a excluir um template de anúncio.
							</Paragraph>
						</Pane>
					</Dialog>
				</Pane>
			</Fragment>
		);
	}
}
